import { Button, Grid, Pagination, Table, Typography } from "antd";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router";
import StatusTag from "../../../components/StatusTag";
import UpdatedByCell from "../../../components/UpdatedByCell";
import { useTableHeight } from "../../../hooks/useTableHeight";

export default function ProgramSection({
  id,
  programData,
  isLoading,
  isRefetching,
  dataParams,
  handleChangePage,
}) {
  const breakpoint = Grid.useBreakpoint();
  const navigate = useNavigate();
  const tableHeight = useTableHeight();

  const columns = [
    {
      title: "No",
      align: "center",
      dataIndex: "id",
      width: 50,
      fixed: breakpoint.md && "left",
      render: (text, record, index) =>
        (programData?.pagination.page - 1) * dataParams.limit + index + 1,
    },
    {
      title: "Nama Program",
      dataIndex: "name",
      width: 130,
      fixed: breakpoint.md && "left",
    },
    {
      title: "Jenis Program",
      dataIndex: "programType",
      width: 150,
      render: (val) => (
        <div>
          <Typography.Text
            style={{
              color: val == "Pendidikan" ? "green" : "blue",
            }}
          >
            {val}
          </Typography.Text>
        </div>
      ),
    },
    {
      title: "Kapasitas Peserta",
      dataIndex: "classCapacity",
      width: 140,
    },
    {
      title: "Tanggal Pengajuan",
      dataIndex: "submissionTime",
      width: 150,
      render: (value) => (
        <Typography.Text style={{ fontSize: "13px", fontStyle: "italic" }}>
          {value
            ? new Date(value).toLocaleDateString("id-ID", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
            : "-"}
        </Typography.Text>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 150,
      render: (val) => <StatusTag status={val} />,
    },
    {
      title: "Update By",
      width: 150,
      render: (record) => <UpdatedByCell value={record} />,
    },
    {
      className: "last-cell-p",
      title: "Aksi",
      align: "right",
      fixed: "right",
      width: 80,
      render: (record) => (
        <Button
          icon={<Icon icon="solar:eye-bold-duotone" width="18" height="18" />}
          color="default"
          variant="filled"
          onClick={() =>
            navigate(
              `/institutional-verification/detail/${id}/program/${record.uuid}`,
            )
          }
        />
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        pagination={false}
        size="small"
        loading={isLoading || isRefetching}
        rowKey={"id"}
        scroll={{ y: tableHeight, x: 1000 }}
        dataSource={programData?.data}
      />

      <Pagination
        style={{ marginInline: 24, marginTop: 16 }}
        total={programData?.pagination?.total}
        showSizeChanger={{
          showSearch: false,
        }}
        pageSizeOptions={["10", "20", "50"]}
        current={programData?.pagination?.page}
        pageSize={dataParams.limit}
        align="end"
        onChange={handleChangePage}
      />
    </>
  );
}
